module.exports = __webpack_public_path__ + "static/media/catchup_billboard_WideScreen@2x.9c8eaf07.png";